'use strict';

module.exports = require('./components/DocEditor/controlEditor').default;


//////////////////
// WEBPACK FOOTER
// ./~/coact/controlEditor.js
// module id = 1892
// module chunks = 0